import { BaseModel, ID } from '@models/base'
import { UserModel } from '@models/user'

import { CashierModel } from './cashier'
import { SalesInvoiceModel } from './salesInvoice'

export enum CashierSessionStatusEnum {
  ACTIVE = 'ACTIVE',
  CASHIER_CLOSED = 'CASHIER_CLOSED',
  SESSION_ENDED = 'SESSION_ENDED',
  SUMMARIZED = 'SUMMARIZED',
}

export type CashierSessionEndingMoneyModel = {
  cashier_session_id: ID
  amount: number
  notes_100000?: number
  notes_75000?: number
  notes_50000?: number
  notes_20000?: number
  notes_10000?: number
  notes_5000?: number
  notes_2000?: number
  notes_1000?: number
  coins_1000?: number
  coins_500?: number
  coins_200?: number
  coins_100?: number
}

export type CashierSessionModel = BaseModel & {
  cashier: CashierModel
  cashier_id: ID
  difference_cash: number
  difference_receipt_count: number
  duration: number // in seconds
  ended_at?: string
  ended_cashier_note?: string
  ended_clinic_manager_note?: string
  ending_cash: number
  ending_money: CashierSessionEndingMoneyModel
  receipt_count: number
  revenue_cash: number
  sales_invoices: Array<SalesInvoiceModel>
  started_at: string
  starting_cash: number
  starting_manager_user: UserModel
  starting_manager_user_id: ID
  status: CashierSessionStatusEnum
  system_ending_cash: number
  system_receipt_count: number
  system_revenue_non_cash: number
  total_revenue: number
  user?: UserModel
  user_id: string
}
